define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.buildUrl = void 0;
    function buildUrl(protocol, host, ...resources) {
        return `${protocol.replace(":", "").replace("//", "")}://${host}/${resources ? resources.filter(x => !!x).join("/").replace("//", "/") : ""}`;
    }
    exports.buildUrl = buildUrl;
});
